"use strict";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOnchainDisplayName } from "features/accounts/useOnchainDisplayName";
import { selectWatchedAddressSet } from "features/favorites/selectors";
import { addWatchedAddress, removeWatchedAddress } from "features/favorites/slice";
import { MobileEventName } from "features/telemetry/constants";
import { sendAnalyticsEvent } from "features/telemetry/send";
export function useToggleWatchedWalletCallback(address) {
  const dispatch = useDispatch();
  const isFavoriteWallet = useSelector(selectWatchedAddressSet).has(address);
  const displayName = useOnchainDisplayName(address);
  return useCallback(() => {
    if (isFavoriteWallet) {
      dispatch(removeWatchedAddress({ address }));
    } else {
      sendAnalyticsEvent(MobileEventName.FavoriteItem, {
        address,
        type: "wallet",
        name: displayName?.name
      });
      dispatch(addWatchedAddress({ address }));
    }
  }, [address, dispatch, displayName?.name, isFavoriteWallet]);
}
